import * as _chartIndicator from './chartIndicator';
import * as _depth from './depth';
import * as _exchange from './exchange';
import * as _favorite from './favorite';
import * as _loadingChecker from './loadingChecker';
import * as _meta from './meta';
import * as _locale from './locale';
import * as _market from './market';
import * as _news from './news';
import * as _openForm from './openForm';
import * as _openOrder from './openOrder';
import * as _socket from './socket';
import * as _tickers from './tickers';
import * as _trades from './trades';
import * as _tradeOrders from './tradeOrders';
import * as _userAssets from './userAssets';
import * as _users from './users';
import * as _userTrades from './userTrades';
import * as _settings from './settings';
import * as _theme from './theme';
import * as _orders from './orders';
import * as _jPush from './jPush';
import * as _assets from './assets';
import * as _funds from './funds';
import * as _sendSMS from './sendSMS';
import * as _subAccount from './subAccount';
import * as _subLoginHistory from './subLoginHistory';
import * as _subAsset from './subAsset';
import * as _subOrder from './subOrder';
import * as _transfer from './transfer';
import * as _convert from './convert';
import * as _blog from './blog';
import * as _register from './register';
import * as _account from './account';
import * as _country from './country';
import * as _simplex from './simplex';
import * as _promoCode from './promoCode';
import * as _margin from './margin';
import * as _dust from './dust';
import * as _userConfig from './userConfig';
import * as _webauthn from './webauthn';
import * as _inmail from './inmail';
import * as _vote2 from './vote2';
import * as _recharge from './recharge';

export const chartIndicator = _chartIndicator;
export const depth = _depth;
export const exchange = _exchange;
export const favorite = _favorite;
export const loadingChecker = _loadingChecker;
export const meta = _meta;
export const locale = _locale;
export const market = _market;
export const news = _news;
export const openForm = _openForm;
export const openOrder = _openOrder;
export const socket = _socket;
export const tickers = _tickers;
export const trades = _trades;
export const tradeOrders = _tradeOrders;
export const userAssets = _userAssets;
export const users = _users;
export const userTrades = _userTrades;
export const theme = _theme;
export const settings = _settings;
export const orders = _orders;
export const jPush = _jPush;
export const assets = _assets;
export const funds = _funds;
export const sendSMS = _sendSMS;
export const subAccount = _subAccount;
export const subLoginHistory = _subLoginHistory;
export const subAsset = _subAsset;
export const subOrder = _subOrder;
export const transfer = _transfer;
export const convert = _convert;
export const blog = _blog;
export const register = _register;
export const account = _account;
export const country = _country;
export const simplex = _simplex;
export const promoCode = _promoCode;
export const margin = _margin;
export const dust = _dust;
export const userConfig = _userConfig;
export const webauthn = _webauthn;
export const inmail = _inmail;
export const vote2 = _vote2;
export const recharge = _recharge;
